module.exports = __webpack_public_path__ + "media/images/icons/x-f9ec806be03b2c1e86c10f03b33479a1.svg";